import { MerlinActionTypes } from './merlin.types';

export const initialState = {
  loading: false,
  token: null,
  merlinUrl: null,
  isIframeOpen: false,
  chatId: null,
  chatCookieName: '',
};

const merlinReducer = (state = initialState, action) => {
  switch (action.type) {
    case MerlinActionTypes.MERLIN_GENERATE_TOKEN: {
      return {
        ...state,
        loading: true,
      };
    }
    case MerlinActionTypes.MERLIN_GENERATE_TOKEN_SUCCESS: {
      return {
        ...state,
        loading: false,
        token: action.payload.token,
      };
    }
    case MerlinActionTypes.MERLIN_GENERATE_TOKEN_FAIL: {
      return {
        ...state,
        loading: false,
      };
    }
    case MerlinActionTypes.MERLIN_SET_URL: {
      return {
        ...state,
        loading: false,
        merlinUrl: action.payload.url,
      };
    }
    case MerlinActionTypes.MERLIN_SET_CHAT_DATA: {
      const { chatId, cookieName, isIframeOpen } = action.payload;
      return {
        ...state,
        chatId,
        chatCookieName: cookieName,
        isIframeOpen,
      };
    }
    case MerlinActionTypes.MERLIN_RESET: {
      return {
        ...initialState,
        token: null,
        merlinUrl: null,
        isIframeOpen: false,
        chatId: null,
      };
    }
    default:
      return state;
  }
};

export default merlinReducer;
